

<!-- header end -->

<!-- body -->
<!-- basecamp -->

<sm-title-bar  pageTitle="Contact us">
</sm-title-bar>
<div class="contact_lookzup">
  <div>
      <div class="row">
          
          <div class="col-sm-8" *ngIf="!contactUsFlag">

              <div class="contact_flied">
                <mat-card>
                  <div class="message_heading">
                    <h3>Send a quick message to us
                    </h3>
                    <p>You can drop a message for us here. It can be of various types, primarily related to troubleshooting and resolving issues with a product, service, or system. Or for creating your brand with custom app and website.  If you have encountered a challenge with our technology feel free to update us.</p>
             </div>

             <div class="frm_kp">
             <mat-form-field appearance="outline" class="full-width">
                <mat-label>Name</mat-label>
                <input matInput type="text" placeholder="Enter your name" [(ngModel)]="name">
              </mat-form-field>
            </div>

         

                <div class="c_sectionmj">
                    <div class="row">
                     <div class="col-sm-3">
                      <mat-form-field appearance="outline" class="country-code">
                        <mat-label>Country Code</mat-label>
                        <mat-select
                        [(ngModel)]="selectedCountryCode"
                        required
                        (selectionChange)="onCountrySelected($event)"
                      >
                        <mat-select-trigger>
                          {{ selectedCountryCode.flag }} {{ selectedCountryCode.name }}
                              {{ "(" + selectedCountryCode.dial_code + ")" }}
                        </mat-select-trigger>
                        
                        <mat-option>
                          <ngx-mat-select-search
                            noEntriesFoundLabel="no results found"
                            name="countrysearch"
                            placeholderLabel="Enter country name"
                            [formControl]="searchString"
                            (keyup)="onKey()"
                          ></ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let country of countryList" [value]="country">
                          {{ country.flag }} {{ country.name }}
                          {{ "(" + country.dial_code + ")" }}
                        </mat-option>
                      </mat-select>
                      </mat-form-field>
                   </div>
                   <div class="col-sm-9">
                     <mat-form-field appearance="outline" class="phone-number">
                       <mat-label>Phone</mat-label>
                       <input matInput type="tel" placeholder="Enter your phone number" [(ngModel)]="phone" minlength="3" maxlength="17">
                     </mat-form-field>
                     </div>
                   </div>
                   </div>

                <div class="frm_kp">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Email</mat-label>
                  <input matInput type="text" placeholder="Enter your Email" [(ngModel)]="email">
                </mat-form-field>
                </div>

                <div class="frm_kp">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Subject</mat-label>
                  <input matInput type="text" placeholder="Enter your Subject" [(ngModel)]="subject">
                </mat-form-field>
                </div>

                <div class="frm_kp">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Message</mat-label>
                    <textarea matInput placeholder="Enter additional notes" [(ngModel)]="message"></textarea>
                  </mat-form-field>
                  </div>



              
                  <div class="checkbox_part">
                    <!-- <div class="row">
                      <div class="col-sm-3">
                        <mat-checkbox [(ngModel)]="problemData[0]" class="trga">Issue/Bug Reporting</mat-checkbox>
                      </div>
                      <div class="col-sm-3">
                        <mat-checkbox [(ngModel)]="problemData[1]" class="trga">Feature Request</mat-checkbox>
                      </div>
                      <div class="col-sm-2">
                        <mat-checkbox [(ngModel)]="problemData[2]" class="trga">Feedback</mat-checkbox>
                      </div>
                      <div class="col-sm-2">
                        <mat-checkbox [(ngModel)]="problemData[3]" class="trga">Testimonial</mat-checkbox>
                      </div>
                      <div class="col-sm-2">
                        <mat-checkbox [(ngModel)]="problemData[4]" class="trga">Others</mat-checkbox>
                      </div>
                    </div> -->
                    <div class="support_sef">
                      <mat-chip-list>
                        <mat-chip class="open_rrt" [ngClass]="{'activeb': problemData[0]}" selectable="false" (click)="clickChip(0)">
                          <mat-icon *ngIf="problemData[0]">check</mat-icon> Issue/Bug Reporting
                        </mat-chip>
                        <mat-chip class="open_rrt activeb" [ngClass]="{'activeb': problemData[1]}" selectable="false" (click)="clickChip(1)">
                          <mat-icon *ngIf="problemData[1]">check</mat-icon> Feature Request
                        </mat-chip>
                        <mat-chip class="open_rrt" [ngClass]="{'activeb': problemData[2]}" selectable="false" (click)="clickChip(2)">
                          <mat-icon *ngIf="problemData[2]">check</mat-icon> Feedback
                        </mat-chip>
                        <mat-chip class="open_rrt" [ngClass]="{'activeb': problemData[3]}" selectable="false" (click)="clickChip(3)">
                          <mat-icon *ngIf="problemData[3]">check</mat-icon> Testimonial
                        </mat-chip>
                      
                        <mat-chip class="open_rrt" [ngClass]="{'activeb': problemData[4]}" selectable="false" (click)="clickChip(4)">
                          <mat-icon *ngIf="problemData[4]">check</mat-icon> Others
                        </mat-chip>
                      </mat-chip-list>
                    </div>
                    
                  </div>
                  
                  <div class="cabh_sect">
                    <button mat-flat-button class="cccakl">Clear</button>
                    <button mat-flat-button color="accent" class="submit-btn" (click)="sendContactUs()" [disabled]="!name || !phone || !subject || !message || checkForm() || phone.length < 3"  >Submit</button>
                </div>
                </mat-card>
              </div>
          </div>

          <div class="col-sm-8" *ngIf="contactUsFlag">
            <div class="contact_flied alt_contact" style="height: 447px;">
              <div style="text-align: center;">
                <div class="sdvbtg_sdsf">
                  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 682.667 682.667" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><defs><clipPath id="b" clipPathUnits="userSpaceOnUse"><path d="M0 512h512V0H0Z" fill="#828282" opacity="1" data-original="#000000"></path></clipPath></defs><mask id="a"><rect width="100%" height="100%" fill="#ffffff" opacity="1" data-original="#ffffff"></rect></mask><g mask="url(#a)"><g clip-path="url(#b)" transform="matrix(1.33333 0 0 -1.33333 0 682.667)"><path d="M0 0h-38.255v-169.01H0a9.564 9.564 0 0 1 9.564 9.565V-9.563C9.564-4.283 5.282 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(259.686 195.815)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-5.988 0-10.841-4.854-10.841-10.842v-147.325c0-5.988 4.853-10.843 10.841-10.843h37.418V0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(184.013 195.815)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h-64.661" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(472.588 136.317)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h-52.195" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(460.123 96.507)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h-43.418" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(451.346 56.696)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h-264.071c-17.565 0-31.937-14.372-31.937-31.937v-158.47c0-17.566 14.372-31.938 31.937-31.938h28.503c4.213 0 8.094-2.287 10.134-5.973l27.011-48.801c2.345-4.236 8.435-4.236 10.779 0l27.634 49.925a9.402 9.402 0 0 0 8.228 4.849h21.43v35.623c0 5.989 4.853 10.842 10.842 10.842 2.095 0-2.086 0 0 0h75.673c5.282 0 9.564-4.283 9.564-9.563v-10.126h16.458c15.293.158 24.296 6.663 24.296 7.785A151.824 151.824 0 0 1 28.31-159.92l3.627 6.011v121.972C31.937-14.372 17.565 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(303.523 371.695)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-9.073 0-16.486 7.399-16.486 16.486 0 10.42 9.594 18.202 19.717 16.156 7.355-1.391 13.255-8.045 13.255-16.156C16.486 7.427 9.133 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(98.97 244.724)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-9.073 0-16.486 7.399-16.486 16.486 0 10.42 9.594 18.202 19.717 16.156 7.355-1.391 13.255-8.045 13.255-16.156C16.486 7.427 9.133 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(168.19 244.724)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-9.073 0-16.486 7.399-16.486 16.486 0 10.42 9.594 18.202 19.717 16.156 7.355-1.391 13.255-8.045 13.255-16.156C16.486 7.427 9.133 0 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(237.412 244.724)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0h36.431c10.792 0 19.985 8.39 20.373 19.175.407 11.323-8.654 20.633-19.892 20.633h8.296c10.792 0 19.984 8.39 20.37 19.174.405 11.326-8.653 20.636-19.889 20.636h11.99c10.791 0 19.982 8.39 20.367 19.174.405 11.325-8.653 20.637-19.891 20.637h11.991c11.235 0 20.294 9.305 19.892 20.63-.384 10.786-9.576 19.179-20.37 19.179H-9.78c-11.86 0-20.23 11.622-16.472 22.87l17.556 50.376c4.658 13.366-2.619 27.942-16.1 32.251a17.432 17.432 0 0 1-20.232-7.596l-37.573-62.252a151.868 151.868 0 0 0-21.828-27.865c0-1.122-9.003-7.626-24.296-7.784h-16.459V28.555h19.822C-96.543 28.555-99.184 0-63.33 0H-35" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(414.434 16.889)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0v.001l-2.081-3.448Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(335.46 217.786)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c42.078 31.966 88.615 81.683 94.964 148.002" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(405.53 248.774)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0c-8.84 36.222-41.471 63.129-80.418 63.166-30.931.031-57.896-16.895-72.158-41.989l-.012.004c-6.079-7.51-15.433-7.528-21.528.021l-.006-.007c-14.209 25.13-41.14 42.111-72.069 42.14-45.781.046-82.932-37.024-82.977-82.802a160.537 160.537 0 0 1 5.172-40.614" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(498.857 431.776)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path><path d="M0 0v0c.44.696.889 1.388 1.318 2.092l1.547 2.563-1.547-2.563C.889 1.389.44.697 0 0Z" style="stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1" transform="translate(330.515 209.684)" fill="none" stroke="#828282" stroke-width="15" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-dasharray="none" stroke-opacity="" data-original="#000000" class="" opacity="1"></path></g></g></g></svg>
                </div>
                <h3 style="    font-size: 24px;
                font-weight: 500;
                margin-bottom: 10px;
                margin-top: 20px;
                color: #222;">Thanks for your feedback.</h3>
                <p style="color: #464646;">Our support team will connect with you via the contact information you provided.</p>
              </div>
            </div>
          </div>
          <div class="col-sm-4">

            <div class="contact_us_feed">
            <div class="frm_lookz_cotact">
                <div class="p-a30  m-b30 contact-area">
                    <h4 class="m-b10">Quick connect</h4>
                    <p>If you have any query or question, contact us via physical mail, email or a phone call.</p>
                    <ul class="no-margin">
                        <li class="icon-bx-wraper left m-b30">
                            <div class="icon-bx-xs border-1">
                                <i class="fab fa-map-marker-alt"></i>
                            </div>
                            <div class="icon-content">
                                <h6 class="text-uppercase m-tb0 dlab-tilte">Address:</h6>
                                <p> Logicasana Pvt. Ltd. <br>
                                    2, Jessore Road, Golpark, Dumdum, 
                                    Kolkata, India, Pin- 700028.</p>
                            </div>
                        </li>
                        <li class="icon-bx-wraper left  m-b30">
                            <div class="icon-bx-xs border-1">
                                <i class="fab fa-envelope"></i>
                            </div>
                            <div class="icon-content">
                                <h6 class="text-uppercase m-tb0 dlab-tilte">Email:</h6>
                                <p>info@lookzup.com <br>
                                  support@lookzup.com</p>
                            </div>
                        </li>
                        <li class="icon-bx-wraper left">
                            <div class="icon-bx-xs border-1">
                                <i class="far fa-phone"></i>
                            </div>
                            <div class="icon-content">
                                <h6 class="text-uppercase m-tb0 dlab-tilte">PHONE:</h6>
                             <p style="margin-bottom: 3px;">+91 9147080470</p>
                                  <p>+91 9147080471</p>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- social media start -->
                   <div class="social_media">
              <div class="list_social">
              <a href="https://www.facebook.com/lookzupapp" target="_blank"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 155.139 155.139" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M89.584 155.139V84.378h23.742l3.562-27.585H89.584V39.184c0-7.984 2.208-13.425 13.67-13.425l14.595-.006V1.08C115.325.752 106.661 0 96.577 0 75.52 0 61.104 12.853 61.104 36.452v20.341H37.29v27.585h23.814v70.761h28.48z" style="" fill="#767676" data-original="#010002" opacity="1"></path></g></svg></a>   
              </div>
                <div class="list_social">
               <a href="https://www.instagram.com/lookzup.app/" target="_blank">  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M301 256c0 24.852-20.148 45-45 45s-45-20.148-45-45 20.148-45 45-45 45 20.148 45 45zm0 0" fill="#767676" opacity="1" data-original="#000000" class=""></path><path d="M332 120H180c-33.086 0-60 26.914-60 60v152c0 33.086 26.914 60 60 60h152c33.086 0 60-26.914 60-60V180c0-33.086-26.914-60-60-60zm-76 211c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75zm86-146c-8.285 0-15-6.715-15-15s6.715-15 15-15 15 6.715 15 15-6.715 15-15 15zm0 0" fill="#767676" opacity="1" data-original="#000000" class=""></path><path d="M377 0H135C60.562 0 0 60.563 0 135v242c0 74.438 60.563 135 135 135h242c74.438 0 135-60.563 135-135V135C512 60.562 451.437 0 377 0zm45 332c0 49.625-40.375 90-90 90H180c-49.625 0-90-40.375-90-90V180c0-49.625 40.375-90 90-90h152c49.625 0 90 40.375 90 90zm0 0" fill="#767676" opacity="1" data-original="#000000" class=""></path></g></svg></a> 
              </div>
                <div class="list_social">
                <a href="https://x.com/lookzup" target="_blank"> <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 1226.37 1226.37" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M727.348 519.284 1174.075 0h-105.86L680.322 450.887 370.513 0H13.185l468.492 681.821L13.185 1226.37h105.866l409.625-476.152 327.181 476.152h357.328L727.322 519.284zM582.35 687.828l-47.468-67.894-377.686-540.24H319.8l304.797 435.991 47.468 67.894 396.2 566.721H905.661L582.35 687.854z" fill="#767676" opacity="1" data-original="#000000" class=""></path></g></svg></a> 
              </div>
               <div class="list_social">
              <a href="https://www.linkedin.com/company/lookzup/" target="_blank">   <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 510 510" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M459 0H51C22.95 0 0 22.95 0 51v408c0 28.05 22.95 51 51 51h408c28.05 0 51-22.95 51-51V51c0-28.05-22.95-51-51-51zM153 433.5H76.5V204H153v229.5zm-38.25-272.85c-25.5 0-45.9-20.4-45.9-45.9s20.4-45.9 45.9-45.9 45.9 20.4 45.9 45.9-20.4 45.9-45.9 45.9zM433.5 433.5H357V298.35c0-20.399-17.85-38.25-38.25-38.25s-38.25 17.851-38.25 38.25V433.5H204V204h76.5v30.6c12.75-20.4 40.8-35.7 63.75-35.7 48.45 0 89.25 40.8 89.25 89.25V433.5z" fill="#767676" opacity="1" data-original="#000000" class=""></path></g></svg> </a>
              </div>
                <div class="list_social">
                <a href="https://www.youtube.com/@lookzup" target="_blank">    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 310 310" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M297.917 64.645c-11.19-13.302-31.85-18.728-71.306-18.728H83.386c-40.359 0-61.369 5.776-72.517 19.938C0 79.663 0 100.008 0 128.166v53.669c0 54.551 12.896 82.248 83.386 82.248h143.226c34.216 0 53.176-4.788 65.442-16.527C304.633 235.518 310 215.863 310 181.835v-53.669c0-29.695-.841-50.16-12.083-63.521zm-98.896 97.765-65.038 33.991a9.997 9.997 0 0 1-14.632-8.863v-67.764a10 10 0 0 1 14.609-8.874l65.038 33.772a10 10 0 0 1 .023 17.738z" fill="#767676" opacity="1" data-original="#000000" class=""></path></g></svg></a>
              </div>
            </div>
                <!-- social media start -->

            </div>
         
        </div>
        </div>
       
      </div>
  </div>
</div>



<!-- body -->

<!-- Footer start -->
<!-- footer  -->

<!-- footer end -->

<script src=".././assets/js/jquery-1.12.4.min.js"></script>
<script src=".././assets/js/popper.min.js"></script>
<script src=".././assets/js/bootstrap.min.js"></script>
<script src=".././assets/js/modernizr-3.5.0.min.js"></script>
<script src=".././assets/js/jquery.meanmenu.min.js"></script>
<!-- ma5menu -->
<!-- <script src="assets/js/ma5-menu.min.js"></script> -->
<script src=".././assets/pluging/owl.carousel.min.js"></script>
<script>
    $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 10,
        autoplay: true,
        autoplayTimeout: 3000,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        responsive: {
            0: {
                items: 2
            },
            600: {
                items: 3
            },
            1000: {
                items: 3
            }
        }
    })
</script>
<script>
    $(function() {
        $(".dropbtn ").click(
            function() {
                $('.dropdown-menu', this).stop(true, true).fadeIn("fast ");
                $(this).toggleClass('open');
                $('b', this).toggleClass("caret caret-up ");
            },
            function() {
                $('.dropdown-menu', this).stop(true, true).fadeOut("fast ");
                $(this).toggleClass('open');
                $('b', this).toggleClass("caret caret-up ");
            });
    });
</script>
<script>
    // meanmenu
    $('#mobile-menu').meanmenu({
        meanMenuContainer: '.mobile-menu',
        meanScreenWidth: "992 "
    });

    $('.info-bar').on('click', function() {
        $('.extra-info').addClass('info-open');
    })

    $('.close-icon').on('click', function() {
        $('.extra-info').removeClass('info-open');
    })
</script>
<!-- Call the script -->
<script>
    $(document).ready(function() {
        ma5menu({
            menu: '.site-menu',
            activeClass: 'active',
            position: 'left',
        });
    });
</script>
